import React from 'react'
import DraggableDialog from '@app/components/ui/modals/DraggableDialog'
import { FormulaSheet } from './FormulaSheet'
import { FORMULA_SHEET_TITLE } from './formulaSheetContent'

type Props = {
  open: boolean
  onClose: () => void
  onExited?: () => void
}

const FORMULA_SHEET_DIALOG_ID = 'formula-sheet-dialog'
// Opens below the top nav, and the size caps keep the same gap from the far screen edges.
const SHEET_START = { x: 48, y: 140 }
const SCREEN_EDGE_GAP = 24
const SHEET_MAX_WIDTH = `calc(100vw - ${SHEET_START.x + SCREEN_EDGE_GAP}px)`
const SHEET_MAX_HEIGHT = `calc(100vh - ${SHEET_START.y + SCREEN_EDGE_GAP}px)`

export const FormulaSheetDialog: React.FC<Props> = ({ open, onClose, onExited }) => (
  <DraggableDialog
    id={FORMULA_SHEET_DIALOG_ID}
    nonModal
    hasDialogRole
    hasBackground
    disableBackdropClose
    position='left-top'
    customDefaultCoordinates={SHEET_START}
    open={open}
    onClose={onClose}
    onExited={onExited}
    title={FORMULA_SHEET_TITLE}
    paperStyles={{
      width: `min(360px, ${SHEET_MAX_WIDTH})`,
      maxWidth: SHEET_MAX_WIDTH,
      maxHeight: `min(500px, ${SHEET_MAX_HEIGHT})`,
    }}
  >
    <FormulaSheet />
  </DraggableDialog>
)
